import React from 'react';
import { connect, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { CLOSE_USER_PROMPT } from '../actions/actionTypes';
import { USER_PROMPT_MODE } from '../lib/constants';
import ColorSF2 from '../styles/common/ColorSF2';

const style = {
  main: {
    position: 'absolute',
    top: 0,
    left: 0,
    background: 'rgba(0,0,0,0.5)',
    height: '100vh',
    width: '100vw',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  body: {
    width: 400,
    height: 150,
    backgroundColor: ColorSF2.white,
    transitionDuration: '0.3s',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'space-around',
    borderRadius: 10,
  },
  message: {
    lineHeight: '20px',
    textAlign: 'center',
  },
  comments: {
    fontSize: 10,
    textAlign: 'center',
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'space-around',
  },
  buttonDisplay: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonStyle: {
    background: ColorSF2.white,
    borderRadius: 4,
    border: `1px solid ${ColorSF2.mediumGray}`,
    width: 100,
    height: 40,
    fontWeight: 'bold',
    lineHeight: '20px',
  },
};
const UserPrompt = ({
  showUserPrompt,
  promptMessage,
  comments,
  buttonArray,
  onAccept,
  mode,
}) => {
  const intl = useIntl();
  const { formatMessage } = intl;
  const dispatch = useDispatch();
  const messageIsArray = Array.isArray(promptMessage);
  const commentIsArray = Array.isArray(comments);
  const convert = () => {
    const convertPromptMessage = () => {
      if (messageIsArray) {
        // メッセージが配列の場合は複数行表示。現状はstringのarrayのみを想定
        return promptMessage.map(id => formatMessage({ id }));
      }
      if (typeof promptMessage === 'string') {
        // メッセージが文字列の場合は1行表示のメッセージ
        return formatMessage({ id: promptMessage });
      }
      if (typeof promptMessage === 'object' && !!promptMessage) {
        // メッセージがobjectで値がある場合は置換文字列有り
        const stringMessage = formatMessage(
          { id: promptMessage.id },
          { ...promptMessage.values },
        );
        return promptMessage.parse ? JSON.parse(stringMessage) : stringMessage;
      }
      return '';
    };
    const convertedPromptMessage = convertPromptMessage();
    const convertedComments = commentIsArray
      ? comments.map(id => formatMessage({ id }))
      : (comments && formatMessage({ id: comments })) || '';
    const convertedButtonArray = buttonArray.map(button => {
      const newName = formatMessage({ id: button.name });
      return { ...button, name: newName };
    });
    return {
      promptMessage: convertedPromptMessage,
      comments: convertedComments,
      buttonArray: convertedButtonArray,
    };
  };
  const promptMessageForWork =
    mode === USER_PROMPT_MODE.requiredConvert
      ? convert().promptMessage
      : promptMessage;
  const commentsForWork =
    mode === USER_PROMPT_MODE.requiredConvert ? convert().comments : comments;
  const buttonArrayForWork =
    mode === USER_PROMPT_MODE.requiredConvert
      ? convert().buttonArray
      : buttonArray;
  const displayMessage = Array.isArray(promptMessageForWork)
    ? promptMessageForWork.map((str, idx) => {
        const key = `messages${idx}`;
        return <p key={key}>{str}</p>;
      })
    : promptMessageForWork;
  const displayComments = commentIsArray
    ? commentsForWork.map((str, idx) => {
        const key = `comments${idx}`;
        return <p key={key}>{str}</p>;
      })
    : commentsForWork;
  return (
    showUserPrompt && (
      <div style={style.main}>
        <div style={style.body}>
          <div style={style.message}>{displayMessage}</div>
          {comments && <div style={style.comments}>{displayComments}</div>}
          <div style={style.buttonWrapper}>
            {buttonArray &&
              buttonArrayForWork.map((_button, _index) => {
                const buttonKey = `button${_index}`;
                return (
                  <div
                    key={buttonKey}
                    id={`button${_index}`}
                    role="presentation"
                    style={{ ...style.buttonStyle, ...style.buttonDisplay }}
                    className="button"
                    onClick={() => {
                      if (onAccept) {
                        onAccept(_index);
                      }
                      dispatch({ type: CLOSE_USER_PROMPT });
                    }}
                  >
                    {_button.name}
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    )
  );
};

UserPrompt.propTypes = {
  showUserPrompt: PropTypes.bool.isRequired,
  promptMessage: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]).isRequired,
  comments: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  buttonArray: PropTypes.array.isRequired,
  onAccept: PropTypes.func,
  mode: PropTypes.number,
};

const mapStateToProps = state => ({
  showUserPrompt: state.userPrompt.showUserPrompt,
  promptMessage: state.userPrompt.promptMessage,
  comments: state.userPrompt.comments,
  buttonArray: state.userPrompt.buttonArray,
  onAccept: state.userPrompt.onAccept,
  mode: state.userPrompt.mode,
});

UserPrompt.defaultProps = {
  onAccept: () => {},
  mode: USER_PROMPT_MODE.default,
};

export default connect(mapStateToProps)(UserPrompt);
